import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import React from 'react'

const SearchField = ({searchValue, handleSearchChange}) => {
  return (
    <div className="search-container d-flex justify-content-center my-2">
    <TextField
      id="search"
      name="search"
      className="search-field"
      placeholder="Search here..."
      value={searchValue}
      onChange={handleSearchChange}
      variant="outlined"
       size="small"
       fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": { borderColor: "transparent" },
          "&:hover fieldset": { borderColor: "transparent" },
          "&.Mui-focused fieldset": { borderColor: "transparent" },
        },
      }}
    />
  </div>
  )
}

export default SearchField